export class VariantValue {

  constructor(
    public name?: string,
    public value?: string,
    public disabled?: boolean
  ) {
  }
}
